import { Flex } from 'components/base'
import { Image } from 'components/icons'
import { Text, TextSize, Weight } from 'components/typography'
import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

//INFO: styles for titles in invest and received sections
export const SectionTitle = styled(Text)`
  font-size: ${TextSize.four};
  font-weight: ${Weight.Medium};
  margin-bottom: 10px;
`

//INFO: styles for currency values and it's wrapper

export const CurrencyValueContainer = styled(Flex)`
  gap: 5px;
  align-self: flex-end;
`

export const CurrencyValue = styled(Text)`
  font-size: ${TextSize.tiny};
  color: ${GLOBAL_COLORS.investCurrencyGrey};
`

//INFO: styles for bold amounts
export const BoldAmount = styled(Text)`
  font-size: ${TextSize.two};
  font-weight: ${Weight.Bold};
`

//INFO: styled for 'max' button
export const MaxButton = styled.a`
  font-size: ${TextSize.tiny};
  color: ${({ theme }) => theme.text1};
  text-decoration: underline;
  cursor: pointer;
`

//INFO: asset container styles
export const AssetWrapper = styled(Flex)`
  gap: 5px;
`

export const AssetIcon = styled(Image)`
  background-size: cover;
  height: 24px;
  width: 24px;
  border-radius: 50%;
`
